import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';
import styles from './FieldPayerName.module.scss';

const FieldPayerName = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-payerName',
    defaultMessage: 'Payer name'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField({name: 'payerName'});
  const [checkbox] = useField<boolean>({name: 'payerIsCustomer'});

  return (
    <>
      {!checkbox.value && (
        <InputText
          {...field}
          {...meta}
          variant={'full'}
          id={field.name}
          label={
            <div className={styles.labelContainer}>
              <span>{labelText}</span>
            </div>
          }
          defaultValue={field.value}
          placeholder={placeholder}
        />
      )}
    </>
  );
};

export default FieldPayerName;
